import slide01 from "../../assets/banner01.png";
import slide02 from "../../assets/banner02.png";
import slide03 from "../../assets/banner03.png";
export const SliderData = [
  {
    image: slide01,
  },
  {
    image: slide02,
  },
  {
    image: slide03,
  },
];
